export const SET_CURRENT_CARD = "SET_CURRENT_CARD"
export const SET_CURRENT_LIST = "SET_CURRENT_LIST"
export const FILTER_LIST = "FILTER_LIST"
export const SET_ALT_IMG_ID = "SET_ALT_IMG_ID"
export const DISPLAY_LIST_SCREEN = "DISPLAY_LIST_SCREEN"
export const DISPLAY_CARD_SCREEN = "DISPLAY_CARD_SCREEN"
export const SET_LOADING = "SET_LOADING"
export const SET_ERROR = "SET_ERROR"
export const RESET_FETCH_STATE = "RESET_FETCH_STATE"
